exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.sorting[data-v-c63fabb6] {\n  position: absolute;\n  left: 319px;\n  z-index: 1000;\n  width: 200px;\n}\n#addUser[data-v-c63fabb6] {\n  margin-bottom: 10px;\n}\n.VuePagination[data-v-c63fabb6] {\n  text-align: right !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-c63fabb6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/trip/CompletedTrip.vue
// module id = 231
// module chunks = 0